<template>
    <div class="blog-post">
      <div class="post-header">
        <div class="thumbnail">
            <img src="https://styles.redditmedia.com/t5_35kex/styles/communityIcon_hf0lhh82wp851.png" alt="r/MalaysianPF icon">
          </div>
        
      </div>
      <div class="post-details">
        <span class="posted-by">Posted by Janeeesss1998 • 3 months ago</span>
      </div>
      <div class="post-content">
        <h2>{{ blogTitle }}</h2>
        <p>{{ blogContent }}</p>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'BlogPost',
    props: {
      blogTitle: {
        type: String,
        required: true
      },
      blogContent: {
        type: String,
        required: true
      }
    }
  }
  </script>
  
  <style scoped>
  .thumbnail {
    width: 32px;
    height: 32px;
    border-radius: 50%; /* Makes the thumbnail circular */
    overflow: hidden; /* Hides any content that overflows the circular shape */
    position: relative; /* Allows positioning of child elements */
    background-color: blue; /* Sets the background color to blue */
  }
  
  .thumbnail img {
    position: absolute; /* Positions the image relative to its containing div */
    top: 50%; /* Moves the image 50% from the top */
    left: 50%; /* Moves the image 50% from the left */
    transform: translate(-50%, -50%); /* Centers the image within its container */
    max-width: 120%; /* Adjust the maximum width to display more of the image */
    max-height: 120%; /* Adjust the maximum height to display more of the image */
  }
  .blog-post {
    background-color: #f9f9f9;
    padding: 20px;
    border-radius: 10px; /* Rounds the corners of the entire blog post */
    border: 2px solid #ccc; /* Adds a border around the entire blog post */
  }
  .post-header {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  
  .subreddit-icon {
    width: 30px;
    height: 30px;
    margin-right: 10px;
  }
  
  .subreddit-link {
    color: #0079d3;
    text-decoration: none;
    font-weight: bold;
  }
  
  .posted-by {
    color: #666;
  }
  
  .post-content h2 {
    color: #333;
    margin-bottom: 10px;
  }
  
  .post-content p {
    color: #555;
    line-height: 1.5;
  }
  </style>
  